module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00536.31719cbb.jpg";